import { Injectable } from '@angular/core';

import { LoginPayload } from '@modules/core/interfaces';
import { SignInResponseDTO } from '@paymash/sdk/dto/response';
import { SignInRequestDTO } from '@paymash/sdk/dto/request';
import { Auth } from '@models';

@Injectable({
  providedIn: 'root',
})
export class SignInMapper {
  public mapToEntity(dto: SignInResponseDTO): Auth {
    return {
      accessToken: dto.accessToken,
      refreshToken: dto.refreshToken,
    };
  }

  public mapToDTO(entity: LoginPayload): SignInRequestDTO {
    return {
      email: entity.email,
      password: entity.password,
    };
  }
}
